import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { changePassword, getAuthSession, initializingLogin, logout, RecoverPassword } from '../redux/actions/auth';

export const useDataAuth = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [user_restore, setuser_restore] = useState(null);
    const {
        checkingSession,
        checkingLogin,
        errorLogging,
        isAuth,
        username,
        // dataUser,
        userSession,
        tokenTemporal,
        passwordChangeRequired,
        creatingNewPassword,
        isNotification,
        msg,
        typeMsg,
    } = useSelector(state => state.auth);

    const companySelected = 1;

    useEffect(() => {
        if (passwordChangeRequired) {
            navigate('/login/newPassword/_')
        }
    }, [passwordChangeRequired, navigate])

    const validateAuthSession = (userPool) => {
        dispatch(getAuthSession(userPool));
    }

    const handleLogin = (username, password) => {
        setuser_restore(username);
        dispatch(initializingLogin(username, password));
    };

    const handleRecoverPassword = (username) => {
        dispatch(RecoverPassword(username));
    };

    const handleCreateNewPassword = (TokenTmp, newPassword) => {
        dispatch(changePassword(TokenTmp, newPassword, user_restore));
    }

    const handleLogout = () => {
        sessionStorage.removeItem('user');
        dispatch(logout());
        navigate('/login');
    };

    const handleSetUserRestore = (user_name) => setuser_restore(user_name);

    return [{
        checkingSession,
        checkingLogin,
        errorLogging,
        isAuth,
        username,
        userSession,
        tokenTemporal,
        idCompany: companySelected?.idCompanySelected,
        passwordChangeRequired,
        creatingNewPassword,
        handleLogin,
        handleCreateNewPassword,
        handleRecoverPassword,
        handleLogout,
        handleSetUserRestore,
        isNotification,
        msg,
        typeMsg
    }];
}